import { render } from "./QiniuUps.vue?vue&type=template&id=1780419b"
import script from "./QiniuUps.vue?vue&type=script&lang=js"
export * from "./QiniuUps.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yinshuangyi/Documents/admin-house/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__